import React, { useState, useEffect } from "react";
import { FaPaperPlane } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import KeypadModal from "./KeypadModal";
import ConfirmModal from "./ConfirmModal";
import axios from "axios";
import BASE_URL from "../utils/Urls";

const FIELDS = [
  { key: "documents_credits", label: "Documents", hint: "running credits this month" },
  { key: "gallery_count", label: "Gallery", hint: "approved profile uploads" },
  { key: "work_count", label: "Work", hint: "approved job posts" },
  { key: "selfie_count", label: "Selfie", hint: "approved daily selfies" },
];
const EMPTY = { documents_credits: "", gallery_count: "", work_count: "", selfie_count: "" };

const DpVerificationConfigPopup = ({ onClose }) => {
  const [showMain, setShowMain] = useState(true);
  const [showKeypad, setShowKeypad] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [values, setValues] = useState(EMPTY);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${BASE_URL}/admin/dp-verification-config`);
        const c = res.data?.config;
        if (alive && c) {
          setValues({
            documents_credits: String(c.documents_credits ?? 0),
            gallery_count: String(c.gallery_count ?? 0),
            work_count: String(c.work_count ?? 0),
            selfie_count: String(c.selfie_count ?? 0),
          });
        }
      } catch (err) {
        console.error("❌ Failed to load verification config", err);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const handleChange = (key, value) => {
    if (value === "" || /^\d+$/.test(value)) {
      setValues((prev) => ({ ...prev, [key]: value }));
    }
  };

  const save = async () => {
    try {
      const payload = {
        documents_credits: Number(values.documents_credits) || 0,
        gallery_count: Number(values.gallery_count) || 0,
        work_count: Number(values.work_count) || 0,
        selfie_count: Number(values.selfie_count) || 0,
      };
      await axios.put(`${BASE_URL}/admin/dp-verification-config`, payload);
      setShowConfirm(false);
      setShowMain(false);
      onClose?.();
    } catch (err) {
      console.error("❌ Failed to save verification config", err);
      alert("❌ Failed to save verification gates");
      setShowConfirm(false);
    }
  };

  return (
    <>
      {showMain && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-start z-50 overflow-y-auto py-8">
          <div
            className="bg-white rounded-lg shadow-lg flex flex-col relative animate-slideUp my-auto"
            style={{ width: "520px", maxHeight: "85vh" }}
          >
            <button
              onClick={() => {
                setShowMain(false);
                onClose?.();
              }}
              className="absolute top-3 right-5 text-red-600 hover:text-red-800 z-10"
            >
              <IoClose className="text-2xl" />
            </button>

            <div className="px-6 pt-5 pb-3">
              <h2 className="text-center font-bold text-xl text-gray-800">Verification gates</h2>
              <p className="text-center text-xs text-gray-400">
                Approval-pay thresholds that unlock each verification queue (0 = no gate)
              </p>
            </div>

            <div className="px-6 pb-4 overflow-y-auto" style={{ flex: 1 }}>
              {FIELDS.map((f) => (
                <div
                  key={f.key}
                  className="border border-red-500 rounded-lg p-4 mb-3 flex items-center justify-between"
                >
                  <div className="text-left">
                    <div className="font-bold text-sm text-red-500">{f.label}</div>
                    <div className="text-xs text-gray-400">{f.hint}</div>
                  </div>
                  <input
                    type="number"
                    min="0"
                    value={values[f.key]}
                    onChange={(e) => handleChange(f.key, e.target.value)}
                    className="text-base font-bold text-black text-center w-24 border border-gray-300 rounded px-2 py-1 focus:outline-none"
                  />
                </div>
              ))}
            </div>

            <div className="flex justify-center py-4 border-t border-gray-100">
              <button
                onClick={() => setShowKeypad(true)}
                className="flex items-center justify-center gap-2 bg-gradient-to-r from-purple-800 to-pink-600 text-white font-bold py-3 px-10 rounded-full shadow-lg"
                style={{ border: "2px solid gold" }}
              >
                CHANGE
                <FaPaperPlane className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}

      {showKeypad && (
        <KeypadModal
          type="secondary"
          onGoClick={() => {
            setShowKeypad(false);
            setShowConfirm(true);
          }}
          onClose={() => setShowKeypad(false)}
        />
      )}

      {showConfirm && <ConfirmModal onYes={save} onNo={() => setShowConfirm(false)} />}
    </>
  );
};

export default DpVerificationConfigPopup;
